export default __webpack_public_path__ + "locales/sq-AL/Webhooks.json?hash=09a567574b5dab23b0e37548bf58f3ce";